import { render, staticRenderFns } from "./PortfolioBanner.vue?vue&type=template&id=c4b36d18&"
import script from "./PortfolioBanner.vue?vue&type=script&lang=js&"
export * from "./PortfolioBanner.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioBanner.vue?vue&type=style&index=0&id=c4b36d18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports